import React from 'react'

const Instructor = ({ CoursesDetails }) => {
    const getIncluded = (title) => {
        if (title === 'Technology & Future Trends') {
            return {
                heading: "What's included",
                items: [
                    "18 on‑demand lessons across Foundation, Intermediate and Advanced levels",
                    "Practical examples covering AI, blockchain, IoT, cloud and quantum",
                    "Downloadable worksheets: trends scanner, adoption roadmap, risk checklist",
                    "Real‑world case studies from startups and enterprises",
                    "Lifetime access and future updates",
                    "Certificate of completion"
                ]
            };
        }
        return {
            heading: "What's included",
            items: [
                "Structured lessons with practical examples",
                "Downloadable resources and templates",
                "Community Q&A and support guidance",
                "Certificate of completion"
            ]
        };
    };

    const data = getIncluded(CoursesDetails?.title);

    return (
        <div className="wpo-course-content">
            <div className="wpo-course-text-top">
                <h2>{data.heading}</h2>
                <div className="course-curriculam">
                    <ul>
                        {data.items.map((item, i) => (
                            <li key={i}><span>{item}</span></li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Instructor;